/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyGoogleDriveIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-google" */ './utils').then((m) => m.GoogleDriveIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/google/icon' },
);

const LazyGoogleDriveSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-google-search-result" */ './utils').then(
			(m) => m.GoogleDriveSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/google/search-result-icon' },
);

const LazyGoogleDriveIconBorderlessComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-google-borderless" */ './utils').then(
			(m) => m.GoogleDriveIconBorderless,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/google/icon-borderless' },
);

const LazyGoogleDriveAppSelectorIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-google-app-selector" */ './utils').then(
			(m) => m.GoogleDriveAppSelectorIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/google/app-selector-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const GoogleDriveIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyGoogleDriveIconComponent />
	</Suspense>
);

export const GoogleDriveSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyGoogleDriveSearchResultIconComponent />
	</Suspense>
);

export const GoogleDriveIconBorderless = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyGoogleDriveIconBorderlessComponent />
	</Suspense>
);

export const GoogleDriveAppSelectorIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyGoogleDriveAppSelectorIconComponent />
	</Suspense>
);
